export const Logger = (message: string | string[], servity: "warn" | "error" | "info" = "info") => {
    switch (servity) {
        case "warn":
            // eslint-disable-next-line no-console
            console.warn(message);
            break;
        case "error":
            // eslint-disable-next-line no-console
            console.error(message);
            break;
        case "info":
            // eslint-disable-next-line no-console
            console.info(message);
            break;
    }
};
